module.exports = __webpack_public_path__ + "img/71.feea5f32.jpg";